<template>
  <div class="product-card" v-if="product != null">
    <div class="product-card-info">
      <div class="product-image" @click="$emit('show')">
        <img :src="resolvedImage" alt="Product" />

        <!-- refused Badge -->
        <div v-if="product.has_been_sold === 1 && $route.name !=='myOperations'" class="top-badge badge-accepted">
          <span>{{ $t('sentence.sold') }}</span>
        </div>
        <div v-if="product.refused != null && $route.name === 'myproducts'" class="top-badge badge-refused">
          <i class="mdi mdi-close-circle"></i>
          <span>{{ $t('main.refused') }}</span>
        </div>
        <div v-else-if="urgent_ad" class="boost-badge" :class="boostClass(urgent_ad)">
          <span>{{ $t(`ecommerce.product.${urgent_ad.type}`) }}</span>
        </div>

      </div>

      <div v-show="showBtn" class="menu-container" @click.stop>
        <button class="menu-toggle" @click="menuOpen = !menuOpen" title="Options">
          <i class="mdi mdi-dots-vertical"></i>
        </button>

        <div v-show="menuOpen" class="actions">
          <button v-if="product.validated != null && product.sales_type == 'fixed'"
            @click="$emit('pause'); menuOpen = false" title="Pause" class="btn-action">
            <i class="mdi" :class="product.paused === null ? 'mdi-pause-circle' : 'mdi-play-circle'"></i>
            <span>
              {{ product.paused === null ? $t('action.pause') || 'Pause' : $t('action.resume') || 'Relancer' }}
            </span>
          </button>

          <button
            v-if="product.sales_type == 'fixed' || product.sales_type == 'auction' && product.validated === null && product.auction_status == 1 || product.paused !== null && product.sales_type !== 'fixed'"
            @click="$emit('update'); menuOpen = false" title="Edit" class="btn-action">
            <i class="mdi mdi-pencil"></i>
            <span>{{ $t('action.update') }}</span>
          </button>

          <button
            v-if="product.sales_type == 'fixed' || product.sales_type == 'auction' && product.validated === null || product.paused !== null && product.sales_type !== 'fixed'"
            @click="$emit('delete'); menuOpen = false" title="Delete" class="btn-action">
            <i class="mdi mdi-trash-can"></i>
            <span>{{ $t('action.delete') }}</span>
          </button>
        </div>
      </div>

      <div class="product-info">
        <span v-if="priorityBoost" class="text-danger">
          {{ $t(`ecommerce.product.${priorityBoost.type}`) }}
        </span>
        <h4 @click="$emit('show')" class="product-name">{{ product.name }}
          <span v-if="authUser && authUser?.is_admin && product.user" class="text-primary">({{ product.user?.username
          }})</span>
        </h4>

        <!-- Fixed Price -->
        <div v-if="product.sales_type === 'fixed'" class="price-section" @click="$emit('show')">
          <p class="product-price price mb-1">
            <span
              :class="product.fixed_price > currentOffer && offer.status === 1 ? 'text-decoration-line-through text-muted' : ''">
              {{
                price || product.fixed_price | currency(" DA", 0, { symbolOnLeft: false }) }}</span>
            <span v-if="product.fixed_price > currentOffer"
              :class="offer.status !== 1 ? 'text-decoration-line-through text-danger' : 'text-success'"> {{
                price || currentOffer
                |
                currency(" DA", 0, { symbolOnLeft: false }) }}</span>
          </p>
        </div>

        <!-- Auction Section -->
        <div v-else-if="product.sales_type === 'auction'" class="auction-section" @click="$emit('show')">
          <TimerSimpleLong :class="(parseInt(product.time_left) > 0 && parseInt(product.time_left) < 3600 * 24)
            ? 'text-danger'
            : ''" :timeLeft=product.time_left :isLong="false" :deadline="product.validated"
            :duration="product.duration">
          </TimerSimpleLong>

          <div class="price mt-2">
            <strong>{{ $t("sentence.currentBid") }}:</strong>
            <span class="product-price price">
              {{
                currentBid |
                currency(" DA", 0, { symbolOnLeft: false })
              }}
            </span>

            <span v-if="!currentBid">
              {{ $t("sentence.noBidsForThisProduct") }}
            </span>

          </div>
          <div class="price mt-2" v-if="$route.name === 'BidsList'">
            <strong>{{ $t("ecommerce.autobid") }}:</strong>
            <span class="product-price price">
              {{
                (product.last_auto_bid?.autobid_max ?? 0) |
                currency(" DA", 0, { symbolOnLeft: false })
              }}
            </span>
          </div>

        </div>
        <UserBidStatusComp v-if="$route.name === 'BidsList'" :product="product" />

        <div v-if="$route.name === 'myOperations' || $route.name === 'dashboardBase'" class="d-flex created_at">
          <div v-if="order.status === 'onHold'" class="created_at">{{ $t('attr.ordered') }} {{ order.created_at |
            formatDate }}
          </div>
          <div v-else class="created_at">{{ $t('attr.received') }} {{ product.created_at |
            formatDate }}
          </div>
        </div>

        <div v-if="$route.name === 'BidsList'" class="d-flex align-items-end">
          <UserOfferStatusComp v-if="offer" :offer="offer" :product="product"
            @make-offer="$emit('make-offer', product)" />
        </div>
        <!-- Fixed Price or Auction Bid Button -->
        <div class="d-flex overflow-hidden" v-if="$route.name === 'myproducts'">
          <router-link v-if="
            product.validated &&
            product.sales_type === 'auction' &&
            product.has_been_sold === 0 &&
            product.time_left < 0
          " class="btn btn-resell" :to="{
            name: 'resellProduct',
            params: {
              id: product.id,
            },
          }">{{ $t("sentence.relistProduct") }}</router-link>
          <div v-else class="d-flex overflow-hidden">
            <ProductManagementActions :product="product" :showManage="false" @open-manage="showManageMenu = true"
              @open-boost="showBoostMenu = true" />
          </div>
        </div>
        <div v-if="($route.name === 'myOperations' || $route.name === 'dashboardBase') && showRatingButton"
          class="rating-container mt-2">
          <!-- Display existing rating -->
          <div v-if="product?.my_rate?.rating > 0">
            <div class="rating-display">

              <div class="stars">
                <i v-for="star in 5" :key="star" class="mdi" :class="getStarClass(star)"></i>
              </div>
              <span class="rating-text">{{ product.my_rate.rating.toFixed(1) }}</span>
            </div>
            <span class="rating-card">{{ product.my_rate.message }}</span>
          </div>

          <!-- Rate button when no rating exists -->
          <button v-else class="btn btn-rating" @click="$emit('rate')">
            <i class="mdi mdi-star"></i>
            <span>{{ $t('action.rate') }}</span>
          </button>
        </div>


      </div>
    </div>
    <!-- STATS AT BOTTOM -->
    <div class="stats-wrapper">
      <StatsComp v-if="showStats" :sales_type="product.sales_type" :favorites="product.favorites_count"
        :vues="product.vues" :bids="product.bids.length" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import AlertService from "@/services/alertService";
import config from "@/config.js";
import helper from "@/services/helper";
import ProductManagementActions from '@/components/product-details/ProductManagementActions.vue';
import StatsComp from "@/components/templates/StatsComp.vue";
import TimerSimpleLong from "@/components/templates/TimerSimpleLong.vue";
import UserBidStatusComp from '@/components/product-details/UserBidStatusComp.vue';
import UserOfferStatusComp from '@/components/product-details/UserOfferStatusComp.vue';

export default {
  name: "ProductCard",
  components: {
    TimerSimpleLong,
    StatsComp,
    ProductManagementActions,
    UserBidStatusComp,
    UserOfferStatusComp,
  },
  data() {
    return {
      menuOpen: false,
      storageUrl: config.storageUrl,
      showManageMenu: false,
      showBoostMenu: false,
    };
  },
  emits: [
    'make-auction',
    'make-offer',
    'rate',
    'product-updated', // New emit for when product data changes
  ],
  props: {
    order: Object,
    offer: Object,
    user: Object,
    product: Object,
    pictures: [Array, String],
    price: {
      type: [Number, String],
      required: false,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    showUser: {
      type: Boolean,
      default: false,
    },
    showStats: {
      type: Boolean,
      default: false,
    },
    showBoost: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {

  },
  computed: {
    authUser: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
    resolvedImage() {
      if (!this.product) return "";

      const pics=this.product.pictures;
      const pic=
        Array.isArray(pics)&&pics.length? pics[0]:pics||"";

      return this.storageUrl+pic;
    },

    // Show rating button only for completed orders that haven't been rated yet
    showRatingButton() {
      if (!this.order) return false;

      // Show button for completed/received orders
      const isCompleted=['received', 'completed'].includes(this.order.status);

      return isCompleted;
    },

    // Check if authenticated user has the highest bid
    showHighestBidBadge() {
      if (!this.product||this.product.sales_type!=='auction') return false;

      const bids=this.product.bids||[];
      if (bids.length===0) return false;

      const authUserId=this.$store.state.user?.id;
      if (!authUserId) return false;

      // Highest bid = first element (array assumed sorted DESC)
      const highestBid=bids[0];

      return highestBid.user_id===authUserId;
    },
    currentBid() {
      if (!this.product?.bids||this.product.bids.length===0) {
        return this.product?.starting_price||0;
      }
      return this.product.bids[0].price; // assuming bids are sorted DESC by price
    },
    currentOffer() {
      if (!this.offer) {
        return this.product?.fixed_price||0;
      }
      return this.offer.price; // assuming bids are sorted DESC by price
    },

    // Does the authenticated user have at least one bid?
    hasUserBids() {
      if (!this.authUser||!this.product?.bids) return false;
      return this.product.bids.some(bid => bid.user_id===this.authUser.id);
    },

    // User's highest bid (if any)
    userHighestBid() {
      if (!this.authUser||!this.product?.bids) return null;
      return this.product.bids
        .filter(bid => bid.user_id===this.authUser.id)
        .sort((a, b) => b.price-a.price)[0]?.price||null;
    },

    // Is the authenticated user currently winning?
    userIsWinning() {
      return this.price>this.lowest_price&&this.product.best_bid.price===this.product.user_best_bid.price;
    },

    // Is the user outbid?
    userIsOutbid() {
      return this.hasUserBids&&!this.userIsWinning;
    },

    // Suggested next bid (you can adjust increment logic)
    suggestedNextBid() {
      const price=parseFloat(this.currentBid)||0;

      if (price<100) return price+5;
      if (price<1000) return price+10;
      if (price<2000) return price+50;
      if (price<10000) return price+100;

      return price+Math.ceil(price*0.05);
    },

    // Button text
    bidButtonText() {
      if (!this.hasUserBids) {
        return this.$t('action.placeBid');
      }
      return this.userIsWinning
        ? this.$t('sentence.youHaveHighestBid')
        :this.$t('action.increaseBid');
    },

    // Button class
    bidButtonClass() {
      if (this.product.sales_type==='fixed') {
        return 'btn-primary';
      }

      if (!this.hasUserBids) {
        return 'btn-primary';
      }
      return this.userIsWinning? 'btn-success':'btn-danger';
    },

    // Check if auction is ended
    isAuctionEnded() {

      if (this.product.sales_type!=='auction') return false;
      if (this.product.auction_status===0) return true;
      if (this.product.time_left<0) return true;
      if (!this.product.validated||!this.product.duration) return false;


      return false;
    },
    userBidStatus() {
      const product=this.product;
      if (!product||product.sales_type!=='auction') return null;

      const bids=product.bids??[];
      if (!bids.length) return null;

      const userId=this.$store.state.user?.id;
      if (!userId) return null;

      const userHasBid=bids.some(b => b.user_id===userId);
      if (!userHasBid) return null;

      const isHighest=
        product.best_bid?.price===product.user_best_bid?.price;

      const ended=product.time_left<0;

      if (ended&&isHighest) {
        return {
          // shared
          state: 'WON',
          text: this.$t('sentence.youWonTheAuction'),
          icon: 'mdi-check-circle',

          // alert view
          title: this.$t('sentence.youWonTheAuction'),
          message: '',
          boxClass: 'border-left border-light bg-success',
          textClass: 'text-light',

          // indicator view
          class: 'status-won'
        };
      }

      if (ended&&!isHighest) {
        return {
          state: 'LOST',
          text: this.$t('sentence.youDidNotWinTheAuction'),
          icon: 'mdi-close-circle',

          title: this.$t('sentence.youDidNotWinTheAuction'),
          message: '',
          boxClass: 'border-left border-danger bg-light',
          textClass: 'text-danger',

          class: 'status-losing'
        };
      }

      if (!ended&&isHighest) {
        return {
          state: 'WINNING',
          text: this.$t('sentence.youHaveHighestBid'),
          icon: 'mdi-check-circle',

          title: this.$t('sentence.youHaveHighestBid'),
          message: this.$t('auction.winningBidMessage'),
          boxClass: 'border-left border-success bg-light',
          textClass: 'text-success',

          class: 'status-winning'
        };
      }

      return {
        state: 'OUTBID',
        text: this.$t('sentence.yourBidOverridden'),
        icon: 'mdi-alert-circle',

        title: this.$t('sentence.yourBidOverridden'),
        message: this.$t('auction.outbidMessage'),
        boxClass: 'border-left border-warning bg-light',
        textClass: 'text-warning',

        class: 'status-outbid'
      };
    },

    userWon() {
      return this.userBidStatus?.state==='WON';
    },
    priorityBoost: helper.priorityBoost,
    urgent_ad: helper.urgent_ad,

  },
  methods: {

    boostClass: helper.boostClass,

    getStarClass(position) {
      const rating=this.product.average_rating;
      if (position<=Math.floor(rating)) {
        return 'mdi-star rating-star-filled';
      } else if (position===Math.ceil(rating)&&rating%1!==0) {
        return 'mdi-star-half-full rating-star-half';
      } else {
        return 'mdi-star-outline rating-star-empty';
      }
    },

    editProduct() {
      this.$router.push({
        name: 'ProductEdit',
        params: { id: this.product.id }
      });
    },

    async togglePause() {
      try {
        const confirmed=await AlertService.confirm({
          title: this.product.paused
            ? this.$t('sentence.confirmUnpause')
            :this.$t('sentence.confirmPause'),
        });

        if (!confirmed) return;

        const { data }=await this.$axios.post(`product/toggle-pause/${this.product.id}`);

        if (data.success) {
          // Update local product data
          this.product.paused=data.paused_at;

          AlertService.success(
            data.status==='paused'
              ? this.$t('sentence.productPaused')
              :this.$t('sentence.productUnpaused')
          );

          // Emit event to parent to refresh data if needed
          this.$emit('product-updated', this.product);
        }
      } catch (error) {
        console.error("Error toggling pause:", error);
        AlertService.error(this.$t('sentence.serverError'));
      }
    },

    async deleteProduct() {
      try {
        const confirmed=await AlertService.confirm({
          title: this.$t('sentence.confirmDelete'),
        });

        if (!confirmed) return;

        const response=await this.$axios.delete(`product/${this.product.id}`);

        if (response?.data?.success) {
          AlertService.success(
            this.$t('sentence.productDeleted')
          );

          // Emit event to parent to remove this product from the list
          this.$emit('product-updated', null);

          // Optionally redirect to MyProducts page
          // this.$router.push({ name: 'MyProducts' });
        }
      } catch (error) {
        console.error("Error deleting product:", error);
        AlertService.error(this.$t('sentence.deleteError'));
      }
    },

    async refreshProductData() {
      try {
        const { data }=await this.$axios.get(`product/get/${this.product.id}`);
        // Update the product data
        Object.assign(this.product, data);

        // Emit event to parent
        this.$emit('product-updated', this.product);
      } catch (error) {
        console.error('Error refreshing product data:', error);
      }
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY");
    },
  },
  productSelled(product) {
    return helper.productSelled(product);
  },
};
</script>

<style scoped>
.product-image {
  position: relative;
}


@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}

.bid-status-indicator {
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.bid-status-indicator i {
  font-size: 16px;
}

/* .btn-boost, */
.btn-resell {
  display: flex;
  justify-content: center;
  max-width: 180px;
  width: 180px;
}

/* .btn-boost {
  color: white;
} */

p.price {
  padding-bottom: 5px;
}

.product-card {
  /* flex: 1 1 auto; */
  background-color: white;
  border-radius: 12px;
  padding: 10px 14px;
  box-shadow: 0 2px 8px rgba(14, 21, 27, 0.04);
  cursor: pointer;
  transition: box-shadow 0.18s ease, transform 0.12s ease;
  position: relative;
}

.product-card-info {
  display: flex;
  align-items: center;
}

.product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(14, 21, 27, 0.08);
}

.product-image {
  width: 164px;
  height: 164px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #f2f3f5;
  margin-right: 14px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.menu-container {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
}

.menu-toggle {
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: background 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-toggle:hover {
  background: var(--gray-100);
}

.menu-toggle i {
  font-size: 22px;
  color: var(--color-3);
}

.actions {
  position: absolute;
  top: 0px;
  right: 30px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: white;
  border-radius: 8px;
  padding: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.actions button {
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;
}

.actions button:hover {
  background: var(--gray-100);
}

.actions i {
  font-size: 14px;
  color: var(--color-3);
}

.product-info {

  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.product-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-price {
  font-size: 0.95rem;
  color: var(--color-1);
  font-weight: 600;
}

.product-status {
  font-size: 0.86rem;
  color: #667085;
}

.created_at {
  font-size: 10pt;
  margin-bottom: 4px;
}

.fas {
  font-size: 18pt;
  /* height: 10px;
  width: 10px; */
}

.actions .btn-action {
  display: flex;
  align-items: center;
  /* vertically center icon & text */
  gap: 6px;
  /* space between icon and text */
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 6px 10px;
  width: 100%;
  text-align: left;
}


.actions .btn-action i {
  font-size: 1.1rem;
  line-height: 1;
}


.rating-container {
  /* display: flex; */
  align-items: center;
  margin-top: 0.5rem;
}

.rating-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 8px;
  width: 130px;
}

.stars {
  display: flex;
  gap: 0.15rem;
}

.stars i {
  font-size: 1.1rem;
  transition: transform 0.2s ease;
}

.rating-star-filled {
  color: var(--warning);
}

.rating-star-half {
  color: var(--warning);
}

.rating-star-empty {
  color: var(--gray-500);
}

.rating-text {
  font-weight: 600;
  color: var(--warning-200);
  font-size: 1rem;
}

.rating-card {
  font-weight: 500;
  color: var(--gray-500);
  font-size: 1rem;
  padding: 0.2rem 1rem 0.2rem 0.2rem;
  /* border: 1px solid var(--gray-300); */
}

.boost-badge {
  font-size: 10pt;
}

@media (max-width: 768px) {

  .product-card {
    overflow: hidden;
  }

  .fixed-bottom-actions {
    position: static !important;
  }
}

@media (max-width: 640px) {
  .product-image {
    width: 80px;
    height: 140px;
  }

  .menu-toggle {
    width: 28px;
    height: 28px;
    padding: 6px;
  }

  .menu-toggle i {
    font-size: 14px;
  }

  .actions button {
    padding: 6px 10px;
    font-size: 10pt;
  }
}
</style>